export default __webpack_public_path__ + "cb8eb06c3232170cc37157398e1bcbae.png";